module.exports = __webpack_public_path__ + "img/lake-cabin-13.5ccb33a8.jpg";